const lineChart = {
    types: {
        PREV_LINE: {
            strokeWidth: '0.125rem',
        },
        CURRENT_LINE: {
            strokeWidth: '0.125rem',
        },
        DASHED_LINE: {
            strokeWidth: '0.125rem',
        },
    },
};
export default lineChart;
//# sourceMappingURL=lineChart.js.map